// extracted by mini-css-extract-plugin
export default {"header":"src-modules-page-FormPage-style__header_Lj5sA","logo":"src-modules-page-FormPage-style__logo_0sgI0"};